<script setup lang="ts">
import type { Agent, AgentOnList } from '@@/shared/agent/types';

const props = defineProps<{
  agent: Agent | AgentOnList
}>();

const hasLanguages = computed(() => {
  return props.agent.languages.length > 0;
});
</script>

<template>
  <div
    v-if="hasLanguages"
  >
    <span
      class="text-nowrap"
      v-text="$t(`agent.header.language_spoken`)"
    />
    <ol class="inline ps-2xs">
      <li
        v-for="language of agent.languages"
        :key="language"
        class="inline before:leading-none before:content-['_•_'] first:before:content-none"
        v-text="$t(`references.languages.${language}`)"
      />
    </ol>
  </div>
</template>
